import HeadTittle from '../../../../../components/HeadTittle';
import { VIEW_TYPE } from '../../../../../enums/ViewType';
import { TrafficDetailsApp } from '../Functionality/TrafficDetailsApp';
import TrafficDetailsModal from '../Modal/TrafficDetailsModal';
import DetailsHeader from './DetailsHeader';
import DetailsTable from './DetailsTable';
import TrafficDetailsMap from './TrafficDetailsMap';
import UserDetailsCard from './UserDetailsCard';
import PaymentModal from '../Modal/PaymentModal';
import PaymentConfirmationModal from '../Modal/PaymentConfirmationModal';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const TrafficDetails = (props) => {
    const {
        dateRange,
        setDateRange,
        view,
        setView,
        t,
        finesCount,
        setFinesCount,
        setDetailsModal,
        detailsModal,
        itemSelected,
        setItemSelected,
        userData,
        geofenceName,
        handleOnBack,

        paymentTypeSelect,
        showPaymentModal, setShowPaymentModal,
        showConfirmationPay, setShowConfirmationPay,
        modified,
        setModified
    } = TrafficDetailsApp(props);

    return (
        <>
            <HeadTittle name={'details'} onBack={handleOnBack}/>
            <div className='row w-100'>
                <div className='col-12 col-md-3'>
                    <UserDetailsCard t={t} data={userData} geofenceName={geofenceName} />
                </div>
                <div className='col-12 col-md-9 border-full-shades-100 border-radius-8px'>
                    <DetailsHeader
                        dateRange={dateRange}
                        setDateRange={setDateRange}
                        view={view}
                        setView={setView}
                        t={t}
                        finesCount={finesCount}
                    />
                    {view === VIEW_TYPE.LIST.name && (
                        <>
                            <DetailsTable
                                dateRange={dateRange}
                                setDetailsModal={setDetailsModal}
                                setItemSelected={setItemSelected}
                                t={t}
                                setFinesCount={setFinesCount}
                                modified={modified}
                                setModified={setModified}
                            />
                        </>
                    )}
                    {view === VIEW_TYPE.GRID.name && (
                        <>
                            <TrafficDetailsMap
                                setDetailsModal={setDetailsModal}
                                dateRange={dateRange}
                                setFinesCount={setFinesCount}
                                setItemSelected={setItemSelected}
                                finesCount={finesCount}
                                modified={modified}
                            />
                        </>
                    )}
                </div>
            </div>
            { detailsModal &&
                <TrafficDetailsModal
                    show={detailsModal}
                    onHide={() => {
                        setDetailsModal(false);
                    }}
                    t={t}
                    itemSelected={itemSelected}
                    setShowPaymentModal={setShowPaymentModal}
                    setShowConfirmationPay={setShowConfirmationPay}
                />
            }

            {showPaymentModal &&
                <PaymentModal
                    show={showPaymentModal}
                    onHide={() => {
                        setShowPaymentModal(false);
                    }}
                    paymentTypeSelect={paymentTypeSelect}
                    setShowConfirmationPay={setShowConfirmationPay}
                    setModified={setModified}
                />
            }

            {showConfirmationPay &&
                <PaymentConfirmationModal
                    show={showConfirmationPay}
                    onHide={() => {
                        setShowConfirmationPay(false);
                    }}
                />
            }

        </>
    );
};

export default TrafficDetails;
